import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addRow, getAllSheets, saveSheet } from "../Redux/Actions/TechnicalSheet";
import { getFamily } from "../Redux/Actions/IngredientActions";
import { addSubProduct, fetchProducts } from "../Redux/Actions/productActions";
import axios from "axios";
import "./TechnicalSheet.css";

function TechnicalSheet() {
  const dispatch = useDispatch();

  // États Redux
  const families = useSelector((state) => state.IngredientReducer?.families || []);
  const products = useSelector((state) => state.productReducer?.products || []);
  const [subSheets, setSubSheets] = useState([]);
  const user = useSelector((state) => state.authReducer?.user || {});

  // États locaux
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedSubProduct, setSelectedSubProduct] = useState("");
  const [selectedFamily, setSelectedFamily] = useState("");
  const [selectedIngredient, setSelectedIngredient] = useState("");
  const [selectedSubSheet, setSelectedSubSheet] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [pricePerUnit, setPricePerUnit] = useState(0);
  const [sheetRows, setSheetRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSubSheet, setShowSubSheet] = useState(false);
  const [stockData, setStockData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [invoices, setInvoices] = useState([]); // NOUVEAU: Stocker les factures

  // Charger les données initiales
  useEffect(() => {
    dispatch(getFamily());
    dispatch(getAllSheets());
    dispatch(fetchProducts());
    fetchSubSheets();
    fetchStockData();
    fetchUserLocation();
    fetchInvoices(); // NOUVEAU: Charger les factures
  }, [dispatch]);

  // NOUVEAU: Récupérer toutes les factures
  const fetchInvoices = async () => {
    try {
      const response = await axios.get("/api/Invoices/getInvoices");
      if (response.data && response.data.invoices) {
        setInvoices(response.data.invoices);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des factures:", error);
    }
  };

  // NOUVEAU: Fonction pour trouver le prix moyen d'un ingrédient dans les factures
  const getPriceFromInvoices = (ingredientId) => {
    if (!ingredientId || invoices.length === 0) return 0;
    
    // Récupérer tous les items de factures contenant cet ingrédient
    const invoiceItems = [];
    
    invoices.forEach(invoice => {
      if (invoice.items && Array.isArray(invoice.items)) {
        invoice.items.forEach(item => {
          if (item.ingredient && item.ingredient._id === ingredientId) {
            invoiceItems.push({
              price: item.price || 0,
              quantity: item.quantity || 1,
              date: invoice.date || new Date()
            });
          }
        });
      }
    });
    
    if (invoiceItems.length === 0) return 0;
    
    // Calculer le prix moyen pondéré par la quantité
    let totalQuantity = 0;
    let totalValue = 0;
    
    invoiceItems.forEach(item => {
      totalQuantity += item.quantity;
      totalValue += item.price * item.quantity;
    });
    
    return totalQuantity > 0 ? totalValue / totalQuantity : 0;
  };

  // Fonction pour obtenir le prix le plus récent d'un ingrédient dans les factures
  const getLatestPriceFromInvoices = (ingredientId) => {
    if (!ingredientId || invoices.length === 0) return 0;
    
    let latestPrice = 0;
    let latestDate = new Date(0); // Date très ancienne
    
    invoices.forEach(invoice => {
      if (invoice.items && Array.isArray(invoice.items)) {
        invoice.items.forEach(item => {
          if (item.ingredient && item.ingredient._id === ingredientId) {
            const itemDate = new Date(invoice.date || invoice.createdAt);
            if (itemDate > latestDate) {
              latestDate = itemDate;
              latestPrice = item.price || 0;
            }
          }
        });
      }
    });
    
    return latestPrice;
  };

  // NOUVEAU: Fonction combinée pour obtenir le prix d'un ingrédient
  const getIngredientPrice = (ingredientId) => {
    // Essayer d'abord le prix le plus récent
    const latestPrice = getLatestPriceFromInvoices(ingredientId);
    if (latestPrice > 0) {
      return latestPrice;
    }
    
    // Sinon, utiliser le prix moyen
    const averagePrice = getPriceFromInvoices(ingredientId);
    if (averagePrice > 0) {
      return averagePrice;
    }
    
    // Si pas de facture, utiliser le prix du stock
    const stockItem = stockData.find(item => 
      item.ingredient && (item.ingredient._id === ingredientId || item.ingredient === ingredientId)
    );
    
    return stockItem ? (stockItem.averagePrice || 0) : 0;
  };

  const fetchUserLocation = async () => {
    try {
      const response = await axios.get("/api/auth/me");
      if (response.data.user && response.data.user.localisation) {
        setSelectedLocation(response.data.user.localisation._id || response.data.user.localisation);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération de la localisation:", error);
    }
  };

  const fetchStockData = async () => {
    try {
      const response = await axios.get("/api/Invoices/stock-report");
      setStockData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données du stock", error);
    }
  };

  const fetchSubSheets = async () => {
    try {
      const response = await axios.get("/api/SubTechnicalSheet/getAllSubSheets?populate=ingredient");
      setSubSheets(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des sous-fiches :", error);
    }
  };

  // Fonction pour obtenir le nom de l'ingrédient
  
    const getIngredientNameById = (ingredient) => {
    if (!ingredient) return "Inconnu";
    
    if (typeof ingredient === 'object' && ingredient.name) {
      return ingredient.name;
    }
    
    if (typeof ingredient === 'string') {
      for (const family of families) {
        const found = family?.ingredients?.find(ing => 
          ing._id === ingredient || ing.name === ingredient
        );
        if (found) return found.name;
      }
    }
    
    return "Inconnu";
  };

  // Fonction pour obtenir l'objet ingrédient complet
  const getIngredientObject = (familyName, ingredientName) => {
    const familyObj = families.find(f => f.name === familyName);
    if (!familyObj || !familyObj.ingredients) return null;
    
    return familyObj.ingredients.find(ing => ing.name === ingredientName);
  };

  // Ajouter une sous-fiche à la fiche technique
  const handleAddSubSheet = () => {
    if (!selectedSubSheet) {
      alert("Veuillez sélectionner une sous-fiche");
      return;
    }
  
    const subSheet = subSheets.find(sheet => sheet._id === selectedSubSheet);
    if (!subSheet) {
      alert("Sous-fiche non trouvée");
      return;
    }
  
    if (!subSheet.rows || subSheet.rows.length === 0) {
      alert("Cette sous-fiche ne contient aucune ligne");
      return;
    }
  
    const validRows = subSheet.rows.reduce((acc, row) => {
      try {
        let ingredientInfo = {};
        
        if (row.ingredient && typeof row.ingredient === 'object') {
          ingredientInfo = {
            _id: row.ingredient._id,
            name: row.ingredient.name
          };
        } 
        else if (row.ingredient) {
          const found = families.flatMap(f => f.ingredients || [])
            .find(ing => ing._id.toString() === row.ingredient.toString());
          
          ingredientInfo = {
            _id: row.ingredient,
            name: found?.name || `Inconnu (ID: ${row.ingredient})`
          };
        }
        else {
          console.warn("Ligne ignorée - format d'ingrédient invalide:", row);
          return acc;
        }
  
        // NOUVEAU: Récupérer le prix depuis les factures
        const ingredientPrice = getIngredientPrice(ingredientInfo._id);
        
        acc.push({
          ...row,
          ingredient: ingredientInfo,
          quantity: parseFloat(row.quantity) || 0,
          pricePerUnit: ingredientPrice > 0 ? ingredientPrice : (parseFloat(row.pricePerUnit) || 0),
          cost: parseFloat(row.total) || 
                (parseFloat(row.quantity) * (ingredientPrice > 0 ? ingredientPrice : parseFloat(row.pricePerUnit))) || 0
        });
  
      } catch (error) {
        console.error("Erreur de traitement de ligne:", error, row);
      }
  
      return acc;
    }, []);
  
    if (validRows.length === 0) {
      alert(`Aucune ligne valide dans "${subSheet.nomSub}". Vérifiez la console.`);
      return;
    }
  
    setSheetRows(prev => [...prev, ...validRows]);
    setSelectedSubSheet("");
    setShowSubSheet(false);
    alert(`${validRows.length} ligne(s) ajoutée(s) depuis "${subSheet.nomSub}"`);
  };

  // Ajouter une ligne manuellement - CORRIGÉ POUR AUTO-PRIX
  const addRowHandler = () => {
    if (!selectedIngredient || quantity <= 0) {
      alert("Veuillez sélectionner un ingrédient et une quantité.");
      return;
    }

    const ingredientObj = getIngredientObject(selectedFamily, selectedIngredient);
    
    if (!ingredientObj) {
      alert("Ingrédient non trouvé.");
      return;
    }

    // NOUVEAU: Récupérer automatiquement le prix depuis les factures
    const ingredientPrice = getIngredientPrice(ingredientObj._id);
    
    // Utiliser le prix des factures s'il existe, sinon celui saisi manuellement
    const finalPrice = ingredientPrice > 0 ? ingredientPrice : pricePerUnit;
    
    if (finalPrice <= 0) {
      alert("Veuillez saisir un prix unitaire valide.");
      return;
    }

    const cost = quantity * finalPrice;
    const newRow = {
      ingredient: {
        _id: ingredientObj._id,
        name: ingredientObj.name
      },
      family: families.find(f => f.name === selectedFamily)?._id,
      quantity: parseFloat(quantity),
      pricePerUnit: parseFloat(finalPrice),
      cost: parseFloat(cost.toFixed(3)),
    };

    setSheetRows((prevRows) => [...prevRows, newRow]);
    setSelectedIngredient("");
    setQuantity(0);
    setPricePerUnit(0);
  };

  // Supprimer une ligne
  const deleteRowHandler = (index) => {
    setSheetRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };

  // Calcul du coût total
  const totalCost = sheetRows.reduce((acc, row) => acc + (row?.cost || 0), 0).toFixed(3);

  // Enregistrer la fiche technique
  const savePageHandler = async () => {
    if (!selectedProduct || !selectedSubProduct || sheetRows.length === 0 || !selectedLocation) {
      alert("Veuillez remplir toutes les informations nécessaires avant de sauvegarder.");
      return;
    }
  
    const sheetData = {
      nom: selectedSubProduct,
      product: selectedProduct,
      subProduct: selectedSubProduct,
      localisation: selectedLocation,
      rows: sheetRows.map((row) => ({
        ingredient: row.ingredient._id || row.ingredient,
        quantity: row.quantity,
        pricePerUnit: row.pricePerUnit,
        cost: row.cost,
        family: row.family
      })),
      totalCost: parseFloat(totalCost),
    };
  
    setLoading(true);
  
    try {
      await axios.post("/api/TechnicalSheet/save-sheet", sheetData);
      alert("Fiche technique sauvegardée avec succès !");
  
      const stockReductionPromises = sheetRows.map((row) => {
        const ingredientId = row.ingredient._id || row.ingredient;
        
        if (!ingredientId) {
          console.warn("ID d'ingrédient manquant pour la ligne:", row);
          return Promise.resolve();
        }

        return axios.put("/api/Stock/update", {
          ingredient: ingredientId,
          quantity: row.quantity,
          localisation: selectedLocation
        });
      });
  
      await Promise.all(stockReductionPromises);
      alert("Stock mis à jour avec succès !");
  
      setSelectedProduct("");
      setSelectedSubProduct("");
      setSheetRows([]);
    } catch (error) {
      console.error("Erreur lors de la sauvegarde ou de la mise à jour du stock :", error);
      alert(`Erreur: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="technical-sheet">
      <h2>Fiche Technique</h2>

      {/* Section localisation */}
      <div className="form-section">
        <label>Localisation :</label>
        <select
          value={selectedLocation}
          onChange={(e) => setSelectedLocation(e.target.value)}
          required
        >
          <option value="">Sélectionner une localisation</option>
          <option value="68fe82cd5a28e993bc70dbc3">Spintoss-Les Jardins</option>
          <option value="68fe837c5a28e993bc70dbc4">Spintoss-Tunisia Mall</option>
          <option value="6947e810cf2f41fc52fca859">Spintoss-Spintoss FAB</option>
        </select>
      </div>

      {/* Sélection du produit et sous-produit */}
      <div className="form-section">
        <select
          value={selectedProduct}
          onChange={(e) => setSelectedProduct(e.target.value)}
        >
          <option value="">Sélectionner un produit</option>
          {products.map((product) => (
            <option key={product._id} value={product._id}>
              {product.name}
            </option>
          ))}
        </select>

        <select
          value={selectedSubProduct}
          onChange={(e) => setSelectedSubProduct(e.target.value)}
          disabled={!selectedProduct}
        >
          <option value="">Sélectionner un sous-produit</option>
          {selectedProduct &&
            products
              .find((product) => product._id === selectedProduct)
              ?.subProducts.map((subProduct) => (
                <option key={subProduct._id} value={subProduct._id}>
                  {subProduct.name}
                </option>
              ))}
        </select>
      </div>

      {/* Section Sous-fiche */}
      <div className="form-row">
        <div>
          <label>Sous-fiche :</label>
          <button 
            onClick={() => setShowSubSheet(!showSubSheet)}
            style={{marginRight: '10px'}}
          >
            {showSubSheet ? "Masquer" : "Afficher"}
          </button>
          
          {showSubSheet && (
            <div style={{display: 'inline-block', marginLeft: '10px'}}>
              <select
                value={selectedSubSheet}
                onChange={(e) => setSelectedSubSheet(e.target.value)}
                style={{marginRight: '10px'}}
              >
                <option value="">Sélectionner une sous-fiche</option>
                {subSheets.map((sheet) => (
                  <option key={sheet._id} value={sheet._id}>
                    {sheet.nomSub}
                  </option>
                ))}
              </select>
              <button onClick={handleAddSubSheet}>Ajouter</button>
            </div>
          )}
        </div>
      </div>

      {/* Sélection des ingrédients */}
      <div className="form-row">
        <div>
          <label>Famille :</label>
          <select
            value={selectedFamily}
            onChange={(e) => {
              setSelectedFamily(e.target.value);
              setSelectedIngredient(""); // Réinitialiser l'ingrédient
              setPricePerUnit(0); // Réinitialiser le prix
            }}
          >
            <option value="">-- Sélectionnez une famille --</option>
            {families.map((family) => (
              <option key={family._id} value={family.name}>
                {family.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Ingrédient :</label>
          <select
            value={selectedIngredient}
            onChange={(e) => {
              const selectedName = e.target.value;
              setSelectedIngredient(selectedName);
              
              if (selectedName && selectedFamily) {
                const ingredientObj = getIngredientObject(selectedFamily, selectedName);
                if (ingredientObj) {
                  // NOUVEAU: Récupérer automatiquement le prix depuis les factures
                  const ingredientPrice = getIngredientPrice(ingredientObj._id);
                  
                  if (ingredientPrice > 0) {
                    setPricePerUnit(ingredientPrice.toFixed(3));
                    alert(`Prix unitaire automatiquement rempli depuis les factures : ${ingredientPrice.toFixed(3)} DT`);
                  } else {
                    // Si pas de facture, essayer le stock
                    const stockItem = stockData.find(item => 
                      item.ingredient && (item.ingredient._id === ingredientObj._id || item.ingredient === ingredientObj._id)
                    );
                    if (stockItem && stockItem.averagePrice > 0) {
                      setPricePerUnit(stockItem.averagePrice.toFixed(3));
                    } else {
                      setPricePerUnit(0);
                    }
                  }
                }
              }
            }}
            disabled={!selectedFamily}
          >
            <option value="">-- Sélectionnez un ingrédient --</option>
            {selectedFamily &&
              families
                .find((family) => family.name === selectedFamily)
                ?.ingredients.map((ingredient) => (
                  <option key={ingredient._id} value={ingredient.name}>
                    {ingredient.name}
                  </option>
                ))}
          </select>
        </div>
      </div>

      <div className="form-row">
        <div>
          <label>Quantité :</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="0"
            step="0.001"
            placeholder="Quantité"
          />
        </div>

        <div>
          <label>Prix unitaire (DT) :</label>
          <input
            type="number"
            value={pricePerUnit}
            onChange={(e) => setPricePerUnit(e.target.value)}
            min="0"
            step="0.001"
            placeholder="Prix unitaire"
          />
          {pricePerUnit > 0 && (
            <small style={{color: '#4CAF50', marginLeft: '10px'}}>
              {getLatestPriceFromInvoices(
                getIngredientObject(selectedFamily, selectedIngredient)?._id
              ) > 0 ? 
                "✓ Prix provenant des factures" : 
                "Prix saisi manuellement"}
            </small>
          )}
        </div>
      </div>

      <button onClick={addRowHandler}>Ajouter à la fiche</button>

      {/* Tableau des ingrédients */}
      <table className="sheet-table">
        <thead>
          <tr>
            <th>Ingrédient</th>
            <th>Quantité</th>
            <th>Prix unitaire (DT)</th>
            <th>Coût (DT)</th>
            <th>Source du prix</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {sheetRows.map((row, index) => {
            const priceSource = getLatestPriceFromInvoices(row.ingredient._id) > 0 ? 
              "Facture" : (getPriceFromInvoices(row.ingredient._id) > 0 ? "Moyenne factures" : "Saisi");
            
            return (
              <tr key={index}>
                <td>{getIngredientNameById(row.ingredient)}</td>
                <td>{row.quantity}</td>
                <td>{row.pricePerUnit.toFixed(3)}</td>
                <td>{row.cost?.toFixed(3)}</td>
                <td>
                  <span style={{
                    color: priceSource.includes("Facture") ? '#4CAF50' : '#FF9800',
                    fontSize: '0.9em'
                  }}>
                    {priceSource}
                  </span>
                </td>
                <td>
                  <button onClick={() => deleteRowHandler(index)}>Supprimer</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Total et sauvegarde */}
      <div className="total">
        <strong>Total : {totalCost} DT</strong>
      </div>
      <button className="save-button" onClick={savePageHandler} disabled={loading}>
        {loading ? "Enregistrement..." : "Enregistrer la fiche"}
      </button>
    </div>
  );
}

export default TechnicalSheet;